module.exports = __webpack_public_path__ + "static/media/miniV1V2.18b954a2.png";